import React, { FC } from 'react';
import pageWrapper from '../../hoc/pageWrapper';
import IPageViewModel from '../../interfaces/umbracoNodes/pageViewModel';
import PageContentSliceMapper from '../pageContentSlice';
import SubRouteFragment from './subRouteFragment';

interface Props {
	componentId: number;
	page: IPageViewModel;
}

const SubRoute: FC<Props> = ({ page }) => {
	if (page.Values.ContentSlices && page.Values.ContentSlices.length > 0) {
		return <PageContentSliceMapper page={page} />;
	}
	return <SubRouteFragment page={page} />;
};

export default pageWrapper(SubRoute);
